/**
 * Ateş İnşaat logo — displayed as the app mark.
 */
export default function Logo({ size = 40, className = "", showWordmark = false }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src="/logo.png"
        alt="Ateş İnşaat"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        className="select-none flex-shrink-0"
        draggable={false}
      />
      {showWordmark && (
        <div>
          <div className="font-display font-black text-base tracking-tight text-slate-900 leading-tight">
            ATEŞ İNŞAAT
          </div>
          <div className="text-[10px] text-slate-500 uppercase tracking-widest">
            İmalat Yönetim Sistemi
          </div>
        </div>
      )}
    </div>
  );
}
